import { mapActions,mapGetters } from "vuex"
import debounce from 'lodash.debounce';

export const AreaChoosetMixin = {
    data(){
      return {
        areaLoading: false,
        collapsed: false,// 区域是否收缩
        currSelected: {},
        selectedKeys: [],
        areaTree: [],
        checkStrictly: false,
        iExpandedKeys: [],
        autoExpandParent: true,
        canceldata:[],
        areaArrList: [],
        searchAreaValue: '',
        rootOpened: true,
        // 20220228改为elementui中tree新增的属性
        defaultProps: {
          children: 'children',
          // 仅用于 el-tree 节点显示,拼接了 sonNum;不污染 areaName 原值,业务数据(选中/搜索/提交)不受影响
          label: 'areaNameLabel'
        },
        currentNodeKey: null
      }
    },
    computed: {
      ...mapGetters({
        areaList: 'areaList', 
      })
    },
    watch: {
      searchAreaValue(val) {
        this.$refs.areaTree.filter(val);
        if(val){
          this.$nextTick(() => {
            debounce(() => {
            this.changeTreeNodeStatus(this.$refs.areaTree.store.root.childNodes);
            },500)
          });
        }else{
          this.loadTree()
        }
      }
    },
    methods: {
      onSearchArea() {
        if(this.searchAreaValue){
          this.$nextTick(() => {
            console.log(this.$refs.areaTree.store.root.childNodes)
            this.changeTreeNodeStatus(this.$refs.areaTree.store.root.childNodes);
          });
        }else{
          this.loadTree()
        }
      },
      changeTreeNodeStatus(node) {// 搜索tree后只展开到当前搜索一级
        for (let i = 0; i < node.length; i++) {
          node[i].expanded = false;
          if(!(node[i].visible && node[i].data.areaName.indexOf(this.searchAreaValue)>-1)){
            node[i].expanded = true
            if (node[i].childNodes.length > 0 ) {
              this.changeTreeNodeStatus(node[i].childNodes);
            }
          }
        }
      },
      ...mapActions([ "GetAreaTreeList" ]),
        loadTree() {
            var that = this;
            this.areaLoading = true
            that.areaTree = [];
            console.log(this.areaList)
            if(this.areaList.length === 0) {
              that.GetAreaTreeList().then((res) => {
                if (res.success) {
                  //部门全选后，再添加部门，选中数量增多
                  this.allTreeKeys = [];
                  let arr = [...res.result]
                  this.reWriterWithSlot(arr);
                  this.areaTree = arr
                  this.areaTree[0].disabled = true
                  if(this.rootOpened){
                    this.setThisExpandedKeys(res.result)
                  }
                }
              }).finally(()=> {
                that.areaLoading = false
              })
            }else{
              let arr = [...this.areaList]
              this.reWriterWithSlot(arr)
              this.areaTree = arr
              this.areaTree[0].disabled = true
              if(this.rootOpened){
                this.setThisExpandedKeys(arr)
              }
              this.areaLoading = false
            }
        },
        /**
         * 重新设置标题自定义
         * @param {*} arr 
         */
        reWriterWithSlot(arr){
          for(let item of arr){
            // 仅用于树节点显示的字段,areaName 原值保持不变
            item.areaNameLabel = (item.areaName || '') + (item.sonNum != null ? '(' + item.sonNum + ')' : '')
            if(item.children && item.children.length>0){
              this.reWriterWithSlot(item.children)
              let temp = Object.assign({},item)
              temp.children = {}
              item.scopedSlots={ title: 'title' }
              this.areaArrList.push(temp)
            }else{
              this.areaArrList.push(item)
              item.scopedSlots={ title: 'title' }
            }
          }
        },
        setThisExpandedKeys(arr){
          if(arr && arr.length>0){
            let keys = []
            for(let item of arr){
              if(item.children && item.children.length>0){
                keys.push(item.id)
              }
            }
            this.iExpandedKeys=[...keys]
          }else{
            this.iExpandedKeys=[]
          }
        },
        refresh() {
          this.loading = true;
          this.loadTree();
        },
        onExpand(expandedKeys) {
          console.log('onExpand', expandedKeys)
          this.iExpandedKeys = expandedKeys;
          this.autoExpandParent = false;
        },
        /*
        onSearch(value) {
            let that = this
            if (value) {
              searchAreaByKeywords({keyWord: value}).then((res) => {
                if (res.success) {
                  that.areaTree = []
                  if(!isNull(res.result)) {
                    for (let i = 0; i < res.result.length; i++) {
                        let temp = res.result[i];
                        that.areaTree.push(temp);
                      }
                  }
                } else {
                  that.$message.warning(res.message)
                }
              })
            } else {
              that.loadTree();
            }
        },
        */
        onSearch(value){
          console.log("执行onSearch")
          const expandedKeys = this.areaArrList.map((item) => {
            if (item.title.indexOf(value) > -1) {
              return this.getParentKey(item.key,this.areaTree)
            }
            return null
          }).filter((item, i, self) => item && self.indexOf(item) === i)
  
          console.log(expandedKeys)
          Object.assign(this, {
            iExpandedKeys: expandedKeys,
            searchAreaValue: value,
            autoExpandParent: true,
          })
        },
        getParentKey(currKey,treeData){
          let parentKey
          for (let i = 0; i < treeData.length; i++) {
            const node = treeData[i]
            if (node.children) {
              if (node.children.some(item => item.key === currKey)) {
                parentKey = node.key
              } else if (this.getParentKey(currKey, node.children)) {
                parentKey = this.getParentKey(currKey, node.children)
              }
            }
          }
          return parentKey
        },
        onSelect(selectedKeys, e) {
            this.selectedKeys = selectedKeys;
            this.hiding = false;
            let record = e.node.dataRef;
            // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
            if(e.selected) {
              this.currSelected = Object.assign({}, record);
              // 有的接口是areaId有的接口是userAreaId，兼容两个都写
              this.queryParam.userAreaId = this.currSelected.value;
              this.queryParam.areaId = this.currSelected.value;
            }else{
              this.currSelected = {};
              // 有的接口是areaId有的接口是userAreaId，兼容两个都写
              delete this.queryParam.userAreaId;
              delete this.queryParam.areaId;
            }
            
            
            this.loadData(1);
        },
        getCurrSelectedTitle() {
            return !this.currSelected.title ? '' : this.currSelected.title
        },
        resetAareaData() {
          console.log("areaChoose");
          this.hiding = true;
          this.checkedKeys = [];
          this.currSelected = {};
          this.selectedKeys = [];
          delete this.queryParam.userAreaId;
          delete  this.queryParam.areaId;
          if(this.rootOpened){
            this.setThisExpandedKeys(this.areaTree)
          }

          // 20220228修改的
          this.currentNodeKey = null;
          if(this.$refs.areaTree) {
            this.$refs.areaTree.setCheckedKeys([])
          }
          
        },
        unselect() {
          this.resetAareaData();
          this.loadData(1);
        },

        // 以下是20220228组件改为elementui中tree组件后做的相应的配置
        nodeClick(record,node,data) {
          //this.$refs.areaTree.setCurrentKey(null)
          //this.$refs.areaTree.setCheckedKeys([])
          console.log(record)
          console.log(node)
          console.log(data)
          // 选中和取消选中都会执行此方法，所以需要根据selected进行判做响应操作
          if(node.checked) {
            this.currentNodeKey = record.id
            this.$refs.areaTree.setCheckedKeys([record.id])
            //this.$refs.areaTree.setCurrentKey(record.id)
            this.currSelected = Object.assign({}, record);
            // 有的接口是areaId有的接口是userAreaId，兼容两个都写
            this.queryParam.userAreaId = this.currSelected.id;
            this.queryParam.areaId = this.currSelected.id;
          }else{
            this.currentNodeKey = null
            this.currSelected = {};
            this.$refs.areaTree.setCheckedKeys([])
            // 有的接口是areaId有的接口是userAreaId，兼容两个都写
            delete this.queryParam.userAreaId;
            delete this.queryParam.areaId;
          }
          this.loadData(1);
        },
        filterNode(value, data, node) {
          // if (!value) return true;
          // return data.areaName.indexOf(value) !== -1;
          let names = this.getParent(node,node.data.areaName,'areaName');
          let isName = names.includes(value);
          if(!value){
            return true
          }else if(isName){
            return true
          }
        },
        getParent(node,name,key){ // 递归获取所有父级名称
          if(node.parent && node.parent.data[key]){
            name+=node.parent.data[key]
            return this.getParent(node.parent,name,key);
          }
          return name
        },
        // 一键折叠
        collapseAll(){
          const allNodes = this.$refs.areaTree.store._getAllNodes();
          allNodes&&allNodes.forEach(node => {
            if(node.level != 1){
              node.expanded = false;
            }
          })
        }
    }
}